<template>
  <svg
    aria-hidden="true"
    viewBox="0 0 146 116"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="146"
      height="116"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M120.888 37.7C123.146 37.7 124.976 39.5177 124.976 41.76C124.976 44.0023 123.146 45.82 120.888 45.82H97.528C99.7857 45.82 101.616 47.6377 101.616 49.88C101.616 52.1223 99.7857 53.94 97.528 53.94H110.376C112.634 53.94 114.464 55.7577 114.464 58C114.464 60.2423 112.634 62.06 110.376 62.06H104.434C101.588 62.06 99.28 63.8777 99.28 66.12C99.28 67.6149 100.448 68.9682 102.784 70.18C105.042 70.18 106.872 71.9977 106.872 74.24C106.872 76.4823 105.042 78.3 102.784 78.3H54.312C52.0543 78.3 50.224 76.4823 50.224 74.24C50.224 71.9977 52.0543 70.18 54.312 70.18H31.536C29.2783 70.18 27.448 68.3623 27.448 66.12C27.448 63.8777 29.2783 62.06 31.536 62.06H54.896C57.1537 62.06 58.984 60.2423 58.984 58C58.984 55.7577 57.1537 53.94 54.896 53.94H40.296C38.0383 53.94 36.208 52.1223 36.208 49.88C36.208 47.6377 38.0383 45.82 40.296 45.82H63.656C61.3983 45.82 59.568 44.0023 59.568 41.76C59.568 39.5177 61.3983 37.7 63.656 37.7H120.888ZM120.888 53.94C123.146 53.94 124.976 55.7577 124.976 58C124.976 60.2423 123.146 62.06 120.888 62.06C118.63 62.06 116.8 60.2423 116.8 58C116.8 55.7577 118.63 53.94 120.888 53.94Z"
      fill="#F3F7FF"
    />
    <path
      d="M58.7297 83.4284L60.725 72.3991L92.2367 27.7537L100.344 33.4457L68.5022 78.1891L58.7297 83.4284Z"
      fill="white"
    />
    <path
      d="M96.6062 38.955L92.5513 36.1112L64.7423 75.2215L68.7972 78.0654L96.6062 38.955Z"
      fill="#E7F0FE"
    />
    <path
      d="M71.1084 57.4727L89.1614 32.0872L97.2723 37.7744L68.7017 77.9524C68.7017 77.9524 68.6707 77.9664 68.6562 77.9566L60.603 72.3088C60.603 72.3088 60.5808 72.2796 60.5907 72.2652L66.6432 63.7498"
      stroke="#2064E7"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M100.411 33.1011L96.5945 30.4246L93.2257 35.1623L97.0421 37.8389L100.411 33.1011Z"
      fill="#E7F0FE"
    />
    <path
      d="M68.1099 61.6754L69.8092 59.3165"
      stroke="#2064E7"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M94.3686 26.7691L100.57 31.1185C101.095 31.4865 101.221 32.214 100.851 32.7352L97.2662 37.7762L89.1565 32.0885L92.7408 27.0475C93.1114 26.5264 93.8439 26.4011 94.3686 26.7691Z"
      stroke="#2064E7"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M66.1263 72.9943L91.7374 37.0034"
      stroke="#2064E7"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M59.3386 83.1124L64.2402 75.9296L67.8396 78.5106L59.3386 83.1124Z"
      fill="#E7F0FE"
    />
    <path
      d="M60.7248 72.3991L68.5264 77.8677C68.6419 77.9467 68.6279 78.1202 68.5103 78.1877L59.3852 83.1373C58.9426 83.3769 58.4186 82.9974 58.5119 82.5049L60.4363 72.5187C60.4659 72.384 60.6175 72.3187 60.7297 72.4024L60.7248 72.3991Z"
      stroke="#2064E7"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M89.3521 64.38V67.86"
      stroke="#75A4FE"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M89.3521 72.5V75.98"
      stroke="#75A4FE"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M83.512 70.18H87.016"
      stroke="#75A4FE"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M91.688 70.18H95.192"
      stroke="#75A4FE"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M57.8162 35.96V39.44"
      stroke="#75A4FE"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M57.8162 44.08V47.56"
      stroke="#75A4FE"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M51.9761 41.76H55.4801"
      stroke="#75A4FE"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M60.1521 41.76H63.6561"
      stroke="#75A4FE"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M54.604 85.84L35.624 85.84"
      stroke="#75A4FE"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
  </svg>
</template>
